import { useEffect } from 'react';
import PropTypes from 'prop-types';
import { connectAsync } from 'iguazu';
import { localeMapper, normalizeFace } from '../utility';

const RedirectToLocaleRoute = ({
  loadStatus,
  loadErrors,
  routeLocale,
  router: { location, replace },
}) => {
  const { routeLocale: status } = loadStatus;
  const { routeLocale: error } = loadErrors;

  useEffect(() => {
    const { pathname } = location;

    if (status !== 'complete' || error) {
      if (error && pathname.indexOf('/error') === -1) {
        replace(`${pathname.replace(/\/+$/, '')}/error`);
      }
      return;
    }

    const search = location.search
      .replace(/request_type=\w*&*/, '')
      .replace(/Face=\w*&*/, '')
      .replace(/(&|\?)+$/, '');

    const path = `/${routeLocale}${pathname}${search}`;

    replace(path);
  }, [status, error]);

  return null;
};

RedirectToLocaleRoute.propTypes = {
  loadStatus: PropTypes.shape({
    routeLocale: PropTypes.string.isRequired,
  }).isRequired,
  loadErrors: PropTypes.shape({
    routeLocale: PropTypes.string.isRequired,
  }).isRequired,
  routeLocale: PropTypes.string.isRequired,
  router: PropTypes.shape({
    location: PropTypes.shape({
      pathname: PropTypes.string.isRequired,
      search: PropTypes.string.isRequired,
    }).isRequired,
    replace: PropTypes.func.isRequired,
  }).isRequired,
};

export const ComponentUnderTest = RedirectToLocaleRoute;

const loadDataAsProps = ({
  store: { getState },
  ownProps: { location: { query: { Face: face } } },
}) => {
  let locale = normalizeFace(face);

  if (!locale && global.BROWSER) {
    locale = getState().getIn(['intl', 'activeLocale']);
  }

  locale = localeMapper(locale);

  return {
    routeLocale: () => ({
      status: locale ? 'complete' : 'loading',
      data: locale,
    }),
  };
};

loadDataAsProps.ssr = true;

export default connectAsync({ loadDataAsProps })(RedirectToLocaleRoute);
